import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdLeaf } from "react-icons/io";
import { IoFlashOutline, IoShieldCheckmarkOutline } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa";
import banner2 from "../assets/kinemo.jpeg";

export default function HomeBanner2() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  const highlights = [
    {
      icon: <IoMdLeaf />,
      title: "Climate-Smart Agribusiness",
      copy: "Delivering resilient seeds and sustainable inputs adapted to local and changing climates.",
    },
    {
      icon: <IoFlashOutline />,
      title: "Technology and Innovation",
      copy: "Leveraging precision agriculture and modern production systems to maximize efficiency.",
    },
    {
      icon: <IoShieldCheckmarkOutline />,
      title: "Farmer Empowerment",
      copy: "Supporting farmers with quality inputs, training, and strong market linkages.",
    },
  ];

  return (
    <section
      className="MainBodySection py-5 home-banner-section"
      style={{
        background:
          "radial-gradient(circle at 8% 5%, rgba(24, 92, 54, 0.12), transparent 35%), linear-gradient(180deg, #f8fbf9 0%, #ffffff 100%)",
      }}
    >
      <div className="container">
        <div
          className="row g-4 align-items-center"
          style={{
            background: "#ffffff",
            border: "1px solid rgba(15, 23, 42, 0.08)",
            borderRadius: "26px",
            boxShadow: "0 22px 55px rgba(12, 38, 25, 0.08)",
            overflow: "hidden",
          }}
        >
          <div className="col-lg-5">
            <div
              data-aos="fade-right"
              style={{
                position: "relative",
                height: "100%",
                minHeight: "430px",
                padding: "20px",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  inset: "24px 24px auto auto",
                  width: "140px",
                  height: "140px",
                  borderRadius: "28px",
                  background: "linear-gradient(135deg, rgba(7, 135, 90, 0.25), rgba(7, 135, 90, 0.04))",
                  zIndex: 1,
                }}
              />
              <img
                src={banner2}
                alt="Kinemo team and operations"
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "390px",
                  objectFit: "cover",
                  borderRadius: "22px",
                  position: "relative",
                  zIndex: 2,
                }}
              />
            </div>
          </div>

          <div className="col-lg-7">
            <div className="pe-lg-4 py-4 py-lg-5" data-aos="fade-right">
              <div
                className="font-semi-bold"
                style={{
                  letterSpacing: "0.12em",
                  fontSize: "0.75rem",
                  color: "#356f52",
                }}
              >
                WHO WE ARE
              </div>

              <h2 className="font-bold text-primary mt-3 mb-3">Fostering Ideas for Growth</h2>

              <p className="text-muted mb-4" style={{ lineHeight: 1.75, maxWidth: "95%" }}>
                We are a technology-driven agribusiness company specializing in climate-resilient seeds,
                agrochemicals, poultry feeds, and day-old chicks, supported by strong technical expertise and
                strategic partnerships. By combining large-scale commercial production with sustainable farming
                practices, we empower smallholder and contracted farmers with quality inputs, agronomic knowledge,
                and innovative solutions.
              </p>

              <ul className="list-unstyled mb-4">
                {highlights.map((item) => (
                  <li
                    key={item.title}
                    className="d-flex gap-3 mb-3 p-3"
                    style={{
                      border: "1px solid rgba(30, 41, 59, 0.09)",
                      borderRadius: "14px",
                      background: "linear-gradient(180deg, #ffffff 0%, #f9fcfa 100%)",
                    }}
                  >
                    <span
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "12px",
                        display: "grid",
                        placeItems: "center",
                        color: "var(--primaryColor)",
                        background: "rgba(7, 135, 90, 0.12)",
                        flexShrink: 0,
                      }}
                    >
                      {item.icon}
                    </span>
                    <div>
                      <h6 className="mb-1 font-semi-bold text-secondary">{item.title}</h6>
                      <p className="mb-0 text-muted small">{item.copy}</p>
                    </div>
                  </li>
                ))}
              </ul>

              <button
                className="btn btn-primary btn-padded"
                onClick={() => appContext.navTo({ item: "about_us" })}
                style={{
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  fontWeight: "700",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                Learn More <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
